export default __webpack_public_path__ + "static/media/4.a6416af8.jpg";